import { FunctionComponent } from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { NotificationModel } from 'model/notification/NotificationModels'
import dayjs from 'dayjs';

export class NotificationViewProps {
  notification: NotificationModel;
  onClick: any;
}

/* TODO: 
1. Next reminder needs to show the right date
4. Clear the day when changing to weekly
5. Add monthly limits, and add the warning
6. Update to use the month day in the status string
*/
export const NotificationView: FunctionComponent<NotificationViewProps> = ({ notification, onClick }) => {

  return (
  <div onClick={onClick} className="follow-up-preview">    
    <Grid container>
      <Grid size="grow">
        <Typography variant="h6">
          {notification.title}
        </Typography>
      </Grid>
      <Grid style={{width: "120px"}}>
        <Typography variant="body1">
          <span style={{float: "right", marginTop: "6px"}}>
            {dayjs(notification.sentDate).format('Do MMM')}
          </span>
        </Typography>
      </Grid>
    </Grid>
    <Grid container>
      <Grid size="grow">
        <Typography sx={{ fontSize: 16, wordBreak:"break-word", whiteSpace: "normal"}} color="text.secondary" style={{marginBottom: "6px"}}>
          {notification.recipient}
        </Typography>
      </Grid>
      <Grid style={{width: "60px"}}>
        <Typography sx={{ fontSize: 16, wordBreak:"break-word", whiteSpace: "normal", textAlign: "right"}} color="text.secondary" style={{marginBottom: "6px"}}>
          {`$${notification.amount.toLocaleString()}`}
        </Typography>
      </Grid>
    </Grid>
  </div>
  )
}
export default NotificationView;